import * as css from 'css/exports.module.scss';

import './RecordTags.scss';

import classNames from 'classnames';
import React from 'react';
import { Space } from 'antd';
import { When } from 'react-if';

import { SonarTagDisplay, SonarTagManager } from '../tags';
import { useCurrentUser, useSonarObjectReference } from '@hooks';

export interface SonarRecordTagsProps {
	alignLeft?: boolean;
	sonarObjectId: number;
	hideTagManager?: boolean;
}

export const SonarRecordTags: React.FC<SonarRecordTagsProps> = ({ alignLeft, sonarObjectId, hideTagManager }) => {
	const tagIds = useSonarObjectReference(sonarObjectId)?.tagIds ?? [];

	const { isReadOnly } = useCurrentUser();
	const allowTagEdit = !isReadOnly && !hideTagManager;
	const className = classNames('sonar-record-tags', { 'align-left': alignLeft });

	return (
		<Space
			className={ className }
			size={ Number(css.size4) }
			wrap>
			{ tagIds.map((id) =>
				<SonarTagDisplay
					key={ id }
					tagId={ id } />) }
			<When condition={ allowTagEdit }>
				<SonarTagManager sonarObjectId={ sonarObjectId } />
			</When>
		</Space>
	);
};
